<script>
	import Card from "./Card.svelte";
	import TeamStates from "./TeamStates.svelte";
	import teams from "../data/teams";
	import feed from "../data/feed";

	console.log(feed);

	export let svgConfig;

	let showTeamStates = false;
	let chosen = false;
	let hovered = false;
	$: chosenTeam = () => {
		const team = teams.filter((team) => team.id == chosen);
		return team[0];
	};
	$: byInterest = (a, b) =>
		(a.id == hovered || a.id == chosen) - (b.id == hovered || b.id == chosen);
	$: byChosen = (team) => team.id == chosen;

	const checkShowTeamStates = () => {
		if (document.location.href.includes("showTeamStates")) {
			showTeamStates = true;
		}
	};

	// CHOOSE TEAM
	const chooseTeam = (id) => {
		if (!zoom.moving) {
			chosen = id;
		}
	};

	// ZOOMING
	$: zoom = {
		px: 0,
		py: 0,
		x: svgConfig.x,
		y: svgConfig.y,
		xmin: svgConfig.x,
		ymin: svgConfig.y,
		w: svgConfig.width,
		h: svgConfig.height,
		maxw: svgConfig.width,
		maxh: svgConfig.height,
		minw: svgConfig.width * 0.3,
		minh: svgConfig.height * 0.3,
		unitw: svgConfig.width * 0.1,
		unith: svgConfig.height * 0.1,
		moving: false,
	};
	const zoomIn = () => {
		const origZoom = zoom.w;
		zoom.w = Math.max(zoom.minw, zoom.w - zoom.unitw);
		zoom.h = Math.max(zoom.minh, zoom.h - zoom.unith);
		if (origZoom !== zoom.w) {
			zoom.x = Math.max(zoom.xmin, zoom.x + zoom.unitw * 0.5);
			zoom.y = Math.max(zoom.ymin, zoom.y + zoom.unith * 0.5);
		}
	};
	const zoomOut = () => {
		zoom.w = Math.min(zoom.maxw, zoom.w + zoom.unitw);
		zoom.h = Math.min(zoom.maxh, zoom.h + zoom.unith);
		zoom.x = Math.max(
			zoom.maxw - zoom.w + zoom.xmin,
			zoom.x - zoom.unitw * 0.5
		);
		zoom.y = Math.max(
			zoom.maxh - zoom.h + zoom.ymin,
			zoom.y - zoom.unith * 0.5
		);
	};

	// PANNING
	// TOUCH EVENTS
	const touchStart = (event) => {
		panStart(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
	};
	const touchMove = (event) => {
		panMove(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
	};
	const touchEnd = () => panEnd();

	// MOUSE EVENTS
	const mouseStart = (event) => {
		panStart(event.clientX, event.clientY);
	};
	const mouseMove = (event) => {
		if (zoom.moving) {
			panMove(event.clientX, event.clientY);
		}
	};
	const mouseEnd = () => panEnd();

	// PAN EVENTS
	const panStart = (clientX, clientY) => {
		zoom.px = clientX;
		zoom.py = clientY;
		zoom.origx = zoom.x;
		zoom.origy = zoom.y;
		zoom.moving = true;
	};
	const panMove = (clientX, clientY) => {
		zoom.x = zoom.origx - zoom.unitw * ((clientX - zoom.px) / zoom.unitw);
		zoom.y = zoom.origy - zoom.unith * ((clientY - zoom.py) / zoom.unith);
	};
	const panEnd = () => {
		zoom.px = 0;
		zoom.py = 0;
		zoom.moving = false;
	};
</script>

<svelte:window on:load={checkShowTeamStates} />
{#if showTeamStates}
	<TeamStates {teams} />
{/if}

<div class="map">
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		fill-rule="evenodd"
		clip-rule="evenodd"
		viewBox="{zoom.x} {zoom.y} {zoom.w} {zoom.h}"
		on:touchstart={touchStart}
		on:touchmove={touchMove}
		on:touchend={touchEnd}
		on:mousedown={mouseStart}
		on:mousemove={mouseMove}
		on:mouseup={mouseEnd}
	>
		<defs>
			<!-- DROPSHADOW -->
			<filter id="dropShadow" x="0" y="0" width="200%" height="200%">
				<feDropShadow dx="5" dy="5" stdDeviation="5" />
			</filter>

			<!-- CARD CLIP -->
			<clipPath id="roundedCorner">
				<rect
					x="0"
					y="0"
					width={svgConfig.card.width}
					height={svgConfig.card.height}
					rx="15"
				/>
			</clipPath>
		</defs>
		<path
			id="ocean"
			d="M0 0h690v519H0z"
			class="water"
			on:click={() => (chosen = false)}
		/>
		<rect
			width="100"
			height="520px"
			class="water"
			x="-75"
			on:click={() => (chosen = false)}
		/>
		<g id="outlines">
			<g id="non-participating" on:click={() => (chosen = false)}>
				<path
					id="gl"
					d="M217 0l1 1-1 2h0v1c-1 1-1 4-3 5-3 1 0-2-1-2l-1-1c-2-1 0-4-2-6h7zm-28 29c-1 2 2 7 1 7-3-1 2-3-3-2 0 0 0 0 0 0 1 2 3 2 1 4l-2-1h0v-3c-1-2-3-3-3-5l2-3 4 3zm20-29l2 4-3-3 1 1c1 1 3 5 2 6l-2-1-2 1V7l-1-2v3c1 2 3-2 4 1 1 1-1 1-1 2l-1 1-2 1 3 1 1 1h2v2l-3 2c-2 1-2-2-2-3l-3-2c-1-1 0-3-1-2v2l-1 1-2-1 1 1c0 1-2 0-2 2l1 1-2 4 1-1 2-3 2 3 1 1c1 1-1 1-2 1 0 2 1 2-1 3-1 1-3-1-3-2l-1 1h-3c-1 0-3-6-2-7 1-2 2 3 2 4h3l-2-1-2-4c-2-2-3 2-4 2v-7l-1 1v6l-2-1s-3 3-4 1v-2s0 0 0 0h-1v-3h-1l2 5c-1 2-3-1-3-1l-2-1 1 1-2 1 3-1 1 1h1l4 4c0 3-3 0-4 0s-1 2-2 0l-1-1-2-1c0 1 3 1 2 2h-1v2l2-1 1 1c2 0 2-1 3 2v1c-1 3-3 0-5 1h1l-2 2-1 1h1l1-2h4v2l1 2-1 1h1l1 2h-1 1l1 3h-2l-1 1h3l-2 1c-2 2 2 1 3 1h-1-1c-2 1-3 2-3 4 0 0 0 0 0 0l2-2h2v1l-1 2h-1v2l-3-1 3 1-2 1 1 1-2 1h1l-1 1h0c-1 1 3 0-1 3-1 1-2 0-3-1l2-5-2 3c0 1-2 2-3 0-2-3-1-5 0-8l1-3v-1l-2-1v-3c-1-4-2-2-4-3v-3-4c-1-1-1 1-1-1v-2c-1-2-1 1-1 3l2 1-1 1v1l1 1c0 2-4-2-5-1-2 2 3 1 3 2l1 2h-1 2v1s0 0 0 0c2 1 6 2 3 5-2 2-8 1-9-1v-3s0 0 0 0l-1 3v-1l-2-1 1 2c0 2-3 1-3 1v1c-2 1-4-3-5 0l4 1s-2 0-1 1l7 3-1 2-2-2h-1c-2 1-1 2-3 1l-1-2c-1 0-3 0-2 1h1v1l2 2c1 1 2-1 2-1 3-2 2 0 4 1h5l-1 1h1v1l3 4 4 3h2c1 1-1 2-2 2v-1l-1 1-1-1-1 2-1-2v1c-2 1-2-1-3-1l1 1-1 2c-1 1-2-2-2-2-1-1 1 2-1 2-1 0 0-3-2-2l-1 3-2-2v2h-1l-2-1 1 1-2 2-1-1s0 0 0 0l-1 1-1-1-1 1-1-1c-1 0 0 0 0 0h-4l-3-1-1-1v1l-1-1-1 1-2-2v1c-1 1-2 1-2-1 0 0 0 0 0 0v-2c-1 0-2 3-3 2-2-1 0 0 0-1l-2-2c1 2 2 2 1 3-2 1-4-3-4-3l-1-1 2-1-2-1c0-1 2-3 1-5v1c-3 0 1 3-1 4-1 1-1 0-2-1h1v2c0 2-1 0-1 1l-1 2-2-2-2 1-2-1v1h1l-2 1-1 1c-3 0-1-3-3 0l-1 2s0 0 0 0h-2s0 0 0 0c0 1 0 0 0 0v1l-2 1v-1 1l-3 1 1-1v-1h-1v2l-4 1v-2h-1l-1 1v-1-3l-1 3h-2c0-1-1 2-2 1l-1-2-1 1-3-1h1l1-2-1 1c-1 0-1 2-2 1v-3h-1 1v-1h2l2-1h1l-1-1v-2h-2s-1 0 0 0l1 2c-1 1-1-1-2-1v1l-1 1-1 1-1-2c-5-2 2 4-3 4v-1l-1-1-1 1c-3 1-1-3-1-4v1l-2 1v-2s0 0 0 0l-2 1-1-1s0 0 0 0l1 2-4 2c-5 1 1-2-2-3l-1 1v-1l-1-1-1 2v-1l-1 1 1 1h-1v3l-1 1-1 3v-1s0 0 0 0h-1l1-1-3-1-2-1s0 0 0 0c0 4 1 3 2 5 1 0 0 0 0 0h-2v2l-1 2-2-2-1-2 1-1c-3-3 1 5-1 6l-1-3-1 2-1-2v3s0 0 0 0v-1-1-2h-1l-1 1v1s-1-2 0 0l-1 2c-2 3 1-1-1-3-1-1-2 2-2 2l1 2-2 1v-1c-2-2-3 0-4-1l-1-1-1-2v1l1 2-1 2 1 2c-1 2-2-4-2-4v3l1 2-5 2h1l2 1-2 1c-2 0-3 0-3-2 0 0 0 0 0 0v2l2 1-3 1-2-3c-2 0 2 2 2 3h-1l-2 1c-3-1 3-3-2-3-3 0 3 6 1 5-2 0-3-4-4-5l1 2 2 3h-1-2l-1-2h-1l2 4s0 0 0 0l-2-4 2 5h-2l-1-2 1 2h1c0 2-3 0-3 0l-3-6v1s0 0 0 0l1 2-1 1 1-1 1 3h-3 2l1 1-1-1c-1 2 2 3-1 4-2 0-2-3-2-3s0 0 0 0l-2-2s0 0 0 0l2-2h-1l-1 1v-1c0 1 0 2-1 1 0 0 0 0 0 0H8v-1-1l-2-1 1-1h2l2-1s-1 0 0 0l3-1-1-1c-1 1-5 2-4 0h3c1-1 0-2-1-2 0-1 0 0 0 0l-3 1c-2 0 2-1 2-2l-2-1 2 1-1-1s0 0 0 0h2s0 0 0 0h2v1c3-3-2-1-3-1l-2-3 3 1h4l1-2-2 2-3-1v-1l3 1v-1s2-1 1-2h-2l1 2h-1l-2-2-1 2 1-2h-1s0 0 0 0v0c-3-2-2-1-4 0 0 0 0 0 0 0h1l1-2H6s1-4-2-3v1l-3-2h1l3 1-2-3c0-1 0 0 0 0l2 2 2-1-2-1c-1 0 0 0 0 0l2-1c1-2-3-4-3-6s8 8 5 2c-1-2-5 0-4-4 0 0 0 0 0 0h1l1 1 1 2v-1l-2-1c-1-3 5-2 5-2l-1-1-3 1v-1h0s1-2 2-1c2 1 3 2 3-1 0 0 0 0 0 0l-2 1-2-2c1-2 3 2 4-1l-2-2 1-1h-1v-2c1-3 6-1 8-3 1 0 0 0 0 0l-4-1c-1 0 0 0 0 0s0 0 0 0h3l-2-2c-1-2 3-1 3-1l1-2 1 1v-1h-1l-2-3h1s-1 0 0 0l4 1c1-2-5 0-4-3h1l1-2 1 1h3l-3-1 2-1-1-2h1v1l2 2h2v2h1l1 1v-1l-2-1 2-1h-1l-3-1c-2-1-3-4-1-3 2 0-1 3 2 3l3-1 1 2s0 1 0 0c0 0-1-5 1-4l2 1c1 1-1 2-2 3l1 4v-4c1-2 3 0 4-2 0-2-2 0-3-2l4-4-1-1v1l-2 1 1 1-2 2h-1 1l-2-1h-1c0-1 2-1 1-2 0 0-7 3-8 1l2-1c1-1 2-3 5-3l1 1v1c1 0 4 0 3-1h-3l1-1h-1c-1 1-3 0-2-1h2v-1-1c1 0 0 0 0 0h1v-1h3c0-2-6 1-2-2 1-1 3 1 3 1h4c1 0 3 2 3 4l-1-1 1 1-1-3-4-2-1 1-1-1h-2c-1-1 1-1 1-1l3-3h-2V5h1l2 1v2h3l1 1-2-2-1 1V6c0-1-5 0-2-4 0 0 0 0 0 0l4 1h3l2 2V4h2l1 1h3s0 0 0 0c0 1 0 0 0 0 2 3-2 0 2 3 0 0 0 0 0 0-1-1-2-2-1-3 2 0 3 5 3 3l-2-3-6-2-2 1-3-1c-1 0-5 0-5-2s2 0 3 1l-1-1-1-1h5l1 2s0 1 0 0l-1-2h2c1 1 1 2 3 1l1-1h5v2c-1 2 0 1 1 2l2 1-3-2 1-3h1l1 1-1-1h3v2c0 1 1 4 2 2 0 0-3-2-2-3h2l1 1 1 1-2-2-2-1h3l1 1V0h1l1 1-1-1h143z"
				/>
				<path
					id="is"
					d="M141 130l-7-3 1-1 1-2 1 2s0 0 0 0h2c3-1-1-2 3-3l2 1-1-1h-3 2l-1-1 1-1h3l-1-1-3 1v-1-2l1-1h-2v-1s0 1 0 0l-2-2h-1v1l-1-1s-5 0-1-2c1-1 0 0 1 1h3v1l1-1h2v1c0-1 7 4 5 0h-2l-2-1v-1l4-1h2l-3-1 2-1c0-5-4 0-4 0v-2s0 0 0 0 0 0 0 0h-1v-1l-1 1h-1s-3 1-3-1h1l-3-2c1-4 3 2 4 2 1-1-2-4 0-4s1 6 3 3l-1-1h0v-2c-1-3 1 3 2 2 0-1-3-3-1-4l1 1c1 0-1-3 1-2 3 1 0 5 3 7l1-3s0 0 0 0l-1-3 3 1h-1v-1s0 0 0 0c-1 0-1 2-2-1s1-1 1-1 0 0 0 0 0-1 0 0l1 1h1v2h1v2h1l-1 2 2 1h-2c0 1 4 3 0 3l-2-1v1l1 2-1 1c-1 1 1 0 1 1l-1 1v2c2 0 2-4 3-4 4-2 1 0 1 1-1 2 2 0 2-1 2-1 1-5 2-5 3 1 0 5 2 6 2 2 1-1 1-2l1-1h1s0 0 0 0l3-1v4c0 2 1-2 1 2l-1 2c1 3 1-6 2-6 2-1 2 3 2 4 0 0 0 0 0 0h1c-1-2 0 0 0 0s0 0 0 0l2-2 2 2v-1c1-1 1 1 1 1v-1l1-1v-1-1h2c2 0 1 1 1 2h1c0 2-3 2 0 4l1-1h1c1-1 2-3 3 0h-1c-2 0-2 0-3 2 0 0 0 0 0 0s0 0 0 0l2 1c1 1-2 3-2 3-1 0 0 0 0 0l2 1v1s0 0 0 0c0 1 0 0 0 0-1 1-3 1-2 2 1 0 1-2 2-1l1 1h1v3h-2l-1 1s5 1 1 3l-3-1c0-1 3 1 2 2l-1-1c-1 1 1 1 1 1l-1 1-2 1-1-2 1 2h-2l-1 2h-1l-2 1s0-2-2-2v1s0 0 0 0c-1 0 0 0 0 0l-4 1-3 1h-1l-1-1-1 2-1-1-3-1c-2 0-2 2-2 2h-5c-2 0-3-3-4-4s-2 0-3-2v-1c0-1 2-1 1-2l-1 1v-2l-1 1-1-2h-1z"
				/>
				<path
					id="ma"
					d="M185 520h0l-2-2 1-1-4-5v-1h-2s0 0 0 0h-2l-2-3v1l1 2-1-1v-1l-2-1-3 1-3-2-2 1v-1c-1 0 0 0 0 0h-5c-3 0-7-4-8-8h-2l-1-2-3-1-4 7c-2 4-5 9-9 12-4 4-12 3-17 4v1h-4 74z"
				/>
				<path
					id="tn"
					d="M291 499c3 0 4-2 7-3 1 0 5-3 5-1v2l1-1h-1l5 1h-2 1v1c-1 1 1 2 1 2l1 2s4-4 6-4h1v2l-1 2-2 3c-2 2-5 2-3 6l3 3v1h2v4l2 1h-28l-1-1v-2l-1-5 2-7c-1 0-3 0-2-1l2-1c2-1-1-1 0-2 0 0 3 0 2-1 0 0 0 0 0 0v-1z"
				/>
				<path
					id="dz"
					d="M291 499v1s0 0 0 0c1 1-2 1-2 1-1 1 2 1 0 2l-2 1c-1 1 1 1 2 1l-2 7 1 5v2l1 1H185h0l-2-2 1-1-4-5v-1s0 0 0 0l3 2 7-3c2-2 1-3 3-3 2-2 4 0 4 0 2-1 2-3 3-2 3 0-2 1 3 2l3-3 9-4h10l3-1 1 1h1l4-2c2-1 2 2 3 1v-1h1l2 1 4-2 2 1h7c2 1 3 4 5 4 4 0 1-1 3-2s5 1 6-1c2-2-1-2 3-2l1 1 2 1h1v1c5 0 1-1 3-3 1-1 6 3 7 3 1 1 3-1 3-1h4z"
				/>
				<path
					id="by"
					d="M409 310c1 0-2-1 0-1h2s0 0 0 0c1 1 2-4 3-4l2-1 3-1h3l4-1h8c1-1 1 0 1 1h1v1l2-1c3-1 0 0 1 1h1v-2h2l1-1c1 0-1 1 1 1 1 0 1-2 2-1 2 2-1 1 1 2l1-2 2-2 2 3c1 0 0-2 2-2h1c3 0-2-1 3-1 2 0 1 3 3 2 2 0-1-3-1-4v-3l1-4h2l1-1 3-1v-1l-2-1v-1l-1-1v-1l-1-1v-1c1-1-3-2-3-3v-2c0-2 5 0 6 0l2-4h-1l2-1v-1l-3-1v-2l-4 1h-1l-1-3-4-1-3-3 1-2-4-1 1-2v-1c0-1-3-2-2-3l-1-3h-1l-3-2h-2l-1 1-2 2c-2 1-2-3-2-3-3 0-2 0-4 2l-1-2c-2-1-2 2-4 0l-2 2-1 4h-1-1-1l-3 3h0v4h3l-1 1v1l-2 1-1 2c-2 3-1-1-2 2v1l1 2-1 3c0 1 3 0 2 2h-2s0 0 0 0h-2c-1 1 1 1-1 2h-2v2h-1l-1 2-2-1c-1 0-4 2-5 1 2 5 6 9 6 15 0 0 0 0 0 0-1 1-7 6-4 7l1-1 2 1c2 2 0 5 1 7v1l1-1z"
				/>
				<path
					id="jo"
					d="M600 520l-9-5-1-1h-2l5-4c3-2 15-10 15-14 0-3-2 1-2 1l-2-2 1-1-6-9-5 6-10 14h-9l-2-1c-2-1-2 3-3 0h0v1s0 0 0 0v1l1 2v1h-1 1c0 2 3 8 2 10v1h27z"
				/>
				<path
					id="gr"
					d="M470 501v4l-9 2s-5 3-6 2c-2-2 1-2-4-2h-3-1-2l-2 1-1-3v-2c1-3 2 0 3 1l2-1 1-1c1 1-1 1-1 2h2l1 1 1-1 3-1h8l3-1s-2 2 0 3l1-1c2-2 2 0 4-3m-19-71h0l3-1c2-2-4-4 0-5h1c2 1 5 3 3 4-1 1-2 1-2 3l1 2-2 4v1c-2-1 1-1 0-3l-5 1c-3 0-4-2-5 0l-2 2c-3 1-1-2-4-1-1 1 0 3-2 4-2 0-2-2-4 0l1 1 1 3h2v-1 1l4 2c1 3-3-1-3-1-1-1-4-1-4 1l3 1v2c-2 0-2-2-3-3h-3c-2 2 4 3 4 4h-3l-1-3-5-1c-2-2 0-1 0-3l-1 1-2 1 1 1v3c0 2 2 3 3 4l1 2c1 1 6 3 5 4l-4-1v1l-1 2 1-1v1c1 1 3 1 1 2l-4 2h1s0 0 0 0h4l1 1h2v2l3-1 1 2 4 1c1 1-1 1-1 1l1 1v2c0 1 2 1 1 3h-1v-1l-2-1s0 0 0 0l-3-2c-1-1 0 1-1 1l-4 2h2v1s0 0 0 0v2l4 1c1 1-1 1-2 1h-3v-1h-3c-1 1 2 3 3 4v1h1l1 4v1s0 0 0 0v1l2 2h-1l-1-1h-1c-1-1-2-5-4-1v4c-2-1-1-3-2-4 0 0 0 0 0 0l-1-2-2-1c-4-1 0 3-2 4s-2-2-2-3c0 0 0 0 0 0l-2-2 2-2c0-2-3-3-4-4h-1v-1c-1-1-3 0-2-2h1l1-4v0l3 1c1-1-1-2 1-3s2 1 4 1l4 1 3 1h1l-2-1c0-2 3 1 4-2h-1s0 0 0 0h-4l-1-2-1 2c-2 0 0-4-2-2v1h-4l-4 2-2-1c0-1 0 0 0 0l-1 2-1-1v-2l-2-2v1l-1-2c-1-1-3 2-1-2h-1v-1l-5-3v-2s-2 1-3-1h1v-1c1 0 2 1 2-1l1-1-1-2 3-1 1-4c0-3 1 0 2-3l-1-3 7-2c1-1 0-3 2-3l5-1 1-1v1c1-1-1-2 2-3 0 0 0 0 0 0v-1 1h2l1-1 3-1 5-3h3l2 1s0 0 0 0l1 1 1-1h3v1l5-2zm-38 36c1-2-2 1-2 0l-2-1v2l4-1zm-2 12l-2-1-1 1c0-1 0-3-1-2v1c0 1-1-1 1-4l1 2v1c1 0 3 1 2 2zm32-8l-2-2c-1 0-2 2-4 0v-1l-6-3-2 1h1l1-1 1-1 1-1 3 2 1 1 1-1 1 1h3s0 0 0 0v1h1l1 4c1 1 5-1 4 2-1 2-4 0-4-1-1 0 0 0 0 0l-1-1s0 0 0 0 0 0 0 0z"
				/>
				<path
					id="tm"
					d="M688 312v10c-2 0-2-2-3-2l-1-1-1-2-3 1-2 3c-1 0-1-1-2 1v5c1 2 1-1 2 0l1 3s4 3 2 3l-2-2-2-1h-1l-1-1-1-1 1-7 8-8 5-1zm0-20l-4-7-6-10 2-4 8-11v-1 33zm0 52s0 0 0 0v1h-1l-1-2h-1c-2-2-1-4-1-6l-2-3s0 0 0 0l3 1 2-1v-1l1 1v-3s0 0 0 0v13z"
				/>
				<path
					id="kz"
					d="M688 100s-1-1-2 1l1 2c-1 2-2-2-3 0l1 2-3-1 1-1s-2 0-3-2v-1c-1-1-2 2-4 0l-2-2h-2v-1l-1 4v1l-4 1c-6 3 1 0-2 3h-1-1c-1 1 1 1 1 1h-1l-1 1 2 2-2 3h1l1 1c0 2-2 1-2 2l-1 4v1l-2 4-2 3v1l-1-1v3l-1 1s0 0 0 0v2c0 1 2 1 1 2h-2l-1 3v-1l-2 4c-1 1 2 1 0 2h-1l-1 3h-1v1 1c0 1-3 2-2 3l1 1-1 1-1-1-2 2 1 1h-1s0 0 0 0l-1 2-2-1c-2 1 0 3 0 3-1 0 0-2-1 0s2 0 2 1v2h1l-1 1 3-1v-1h1v1h-1l1 3 3-2h1c1 0 2-2 3-1 2 2 0 2-1 3l-1 1h-1l-1 1-1 2h1c0 1-2 4 0 4h1l1 1h1l1 1v3l-1 2v2c-1 1-2 1-1 2s2-1 4-1v2l4-3 1 1c3-1 0-2 5-1 0 0 0 0 0 0v1c0 1 3 3 3 5-1 2-3 6-5 6h-3c-1 1 2 4 0 6-2 3 1-2-2-1l-3 3h-1l-1-1-1 1v-1l-1 1v-1s0-2-1-1h-2s0 0 0 0c-2 1 0 1 0 2l-3 1c-1 1 2 2 1 3h-1v1l-3-1-1 1-2 2 1 1h-2v2l-1 1 1 2-1 4h-2l-1 1c-1 0-7-3-7 0v1h1c1 0 3 2 2 3h-2l-1-1v-1h-3c-2-1 1-2-3-2l-1 1c-3 0-1-2-4-1l-5 4-3-2c-1-1 0 0 0 0l-1 2h-1c-2 2 1 2 0 4l-1-1c-1 2 0 2-2 2s1-1 0-2c-2-1-2 1-3 2h-2l1 1c0 3 0-1-1 0-1 2 1 2 1 3l-1 3-1 2-1 2-2 1c-1 2 2 2 1 3v1l-1 1-1 3-2 1h1l4 3v2c1 0 1-2 1 0v1c-2 6-3 2-7 1l-4-1v4l1 1-2 4 2 6 3 1v4 5l1 1h5l1 1h1v1l-1 1 2 1s0 0 0 0 0 0 0 0l2 1v-2h2l3-2c4 1 5 3 8 5l4 1c1 1 0 3-1 3 0 0-2-2-2 0-1 3 5 2 7 1l-1-2h2v-1h1l2-3 1-3v-2h1l1-1v1s0 0 0 0v-2h1c0-2-1-2 1-4s4 0 6 0v-1h3l1-4h1c1 0 2-2 3-1l2 1 1 1s0 0 0 0v2s0 0 0 0h1l3 5v6h5c-1 2-4 2-5 3l-4 3h-2v2l-2 1c-1 4 1 2 1 4 1 0 0 0 0 0l-2 2c0 2 3 1 4 1l1 2 1-1h2l-1 1h-2v1c-1 2-2 0-3 0l-1 1c-1 1-4 1-3 3 1 5 5 0 6 1l1 2 8 4 1 3 3-2v1l3 1h1c1 1 1-1 1-1h2c1 0 2-3 4-2v2l-1-1 1 1 1 3v3l2 2 1 2 1-7 8-8 5-1v-20l-4-7-6-10 2-4 8-11V100z"
				/>
				<path
					id="no"
					d="M327 0v1h-1v5h-1l1 1c0 1-2 2-1 3 0 0 2 0 0 2h-2v-1c-2-3 0 3-2-2-1-1 1-2 2-2s0 0 0 0l-1-1-2 1c-1 1-1-1-1-1h-2l-1-5h1v1l1-1 4 1s0 0 0 0l-1-2h-2m21 0l-1 2V0m14 101v1m15 16h0m25-36l1 3h-3c1 1-2 3-3 4v4c-3-1 1-4 0-6-2-3-5-2-8-4v-1s0 0 0 0 0 0 0 0h0l-3 3h-3v2l-1 2 1 4h-1l1 2 1 2c0 3-1 1-2 2v3l-1 1-1-1-4-1-1 2c-1 2-2 0-4 1h-2v-2l-4-4c-4-3-2 3-2 3l-2-1v1s0 0 0 0h0-2c-1 1 1 1 1 2v2l-1 3c0 1 3 0 0 2-1 1-7-2-8-1v7l-3-1-3 4-1 3-1 2c0 2 3 2 2 4l-5 7 1 3-2 1-3 1 1 4v7c-1 2-3 5-3 8-1 1 3 0 2 5 0 4-3 0-7 2l-3 6v1l-1 3c0 11 1-9 1 3l-1 1 1 2-1 2 2 4-1 7 5 4-1 4-3 1c1 4 3 3 2 8v3l-4 3h1v2l-2 1c0 2 2 5 0 8h-1v-1-1c-2-3-1 2-4-1v-2h-1v-2s0 0 0 0l-1-3v-1c-2 0 2 2 0 4 0 0 0 0 0 0v-2l-2-1 1 2v2c1 2 2 1 1 2 0 0 0 0 0 0h-1v3l-1-1c-1 1 2 2-2 2v-1l-2-1 1 2-3 1 1 1-2 1h1c-1 4-2-1-2 1v1l-3 3c0 1 0 0 0 0l-2 2-1-1-1 2h-6s2 0 1-1l-1 1-2-1c-2 0 1-1 1-2v-1l-1 1h-2l-2-3h-1l-2-4 1-1v-2l1 2 1-1s0 0 0 0v-1l1-1c1 0 0 0 0 0l1-1 2-1h-3l-1-1 2-1-2-1c-2 0-1 3-2 3l-1-2h-1s0 0 0 0 0 0 0 0 0 0 0 0v-1h1l1-2 1 1h1c0-1 0 0 0 0 1-1-1-1-1-1l4-2c-3 0-1 3-4 0 0 0 0 0 0 0l1-1h1v-1s0 0 0 0l2-1-1-1v-1h-1l-1 1v2c-1 1-1 0-1-1v-1l1-3c-1 1-2 5-3 3l-1-2 3-1 1-1c-1 1-2-1-2-1l2-1h-2s0 0 0 0 0 0 0 0 0 0 0 0l-1 1v-1l-2-2 2 1s0 0 0 0l2-2s0 0 0 0l-3 1v-3c1-1 2 1 3 1 0 0 2-2 4-1l1 1 2-2c2-1 0 4 3 4l-1-3c0-1 5 2 4-1h-2v-1l2-2c-3-1-2 3-2 3l-2 1v-1h-3v-1 2l-4-1c0-1 0 0 0 0h-4l-1-1 2-2h0l-1 1c-2-1 0-2 1-2h3c1 0-3 1-4-1h2l-2-1c-1-1 1-3 2-3l3 1v0l2 1-1-1h4v-1c-4 0 1 1-2 1l-4-1-2-1-1 1 1-2-1-2h1l1 2-1-2 2 2 1-2v2s0 0 0 0l1-1v1h0v-2l2-2v2l1 1v0c0-2-2-3 1-4l1 3h3l-2-1-1-2-3-1v-1h1l1 1s1-2 2-1l1 1v-1l2 2s2 0 1-1h-2l2-2-2 1c-6 0-1-1-1-2l-2-1c0-1 0-2 3-1l1 1 1-1h1s0 0 0 0l1-1v1h2v2h2l-2-1 1-1c1 0 0 0 0 0-1 0 0 0 0 0h-1l-1-1c0-1 0 0 0 0v-1c1 0 4 2 4 0 0-3-3 2-3-2l3-2 1 2h1l1-1-1 1 1-2 1-2 1 2 1 1-1 1h1l1 1c1-1-1-1-1-2h4l1-2h-1l4-3s-3 0-2-1l2-1c0-4-3 1-4 1l-1 1 2 1s0 0 0 0l-2 1-3 2-1-1v-1l2-1h-1v-1l-2 2c-2-1 0-2 1-3h1v-1-1h1v-1s0 0 0 0h1v-2l1-1c1 0-1 0 0 0h1l-1-1 2-2 2 2h1l1-1c1-2-2 2-2-2l1-1-1 1c-2 0 2-2 2-2h-1v-1s0 0 0 0h3v-1c2-2 4-1 4-3h-1-2c0-1 3-1 2-2h-1s0 0 0 0l-1 2h-1l1-3v-1l2-1s0 0 0 0l-1-1 1-3 2 2v-1l-1-2h-2c-1-1 2-1 2-1l3-1 1 1-1-1h0s0 0 0 0v-1l-3 2c-3-1 2-1 2-2 1 0 0 0 0 0h-2v-2c0-4 2-2 4-3 1-1-2-2-2-2l1-1c1 0-1-1 1-1v0h1v1l2-1-1-2 3-1v0h1-1l1-1-1 1h-3l1-1c0-1 0-4 2-3l-1 1h3l1 2-1-2 2-1h-1c-1 1-2 1-3-1h1s0 0 0 0h2c1-2-2-2-2-2s0 0 0 0l-2 2-1-2h1c-1-1 1-1 1-1v1c2-2 4-1 4-3h-1s0 0 0 0 0 0 0 0h-3c-1-2 3 0 3 0v-3l1 1c0 1 0 0 0 0v2l2 3c2-2-3-6-2-6 1-1 2 0 2 1v-1l-2-1 3-1c4 0 0 2 3 3l-1-3 1 1 2-1c-1-4-3 0-4 0v-1s0 0 0 0l-1 1-2-1v-1h-1v3l-1-2h-1l-1 1-1 1-1 1h0l1-2v-1l2-1c2-2-3-2 0-4 2-3 1 2 1 4v-1h1s0-5 1-3l1 3 1-1 1 1h3l-3-1 1-1h1-1l2-1h-1v-3l2-1-1-1v1h-2l-1 2-2-1 2-1h-1l1-2h-1c1-1 3 0 2-1 0-1-2 0-1-1l1 1 1-2 1 3 1-2 1 3 2-1-2-1 1-2 1 2 2 1 1 1c0-2-5-2-3-6 0-1 2-2 3-1l-1 5 1-1v-2h2l-2-1s1-5 2-3v8c1 1 0-3 1-3h2l-1-1s-2-1-1-2c2-6 0 0 3-2v-2h1v1l2 1 1 1-1-1v-1-3c-1 0-3 3-4 0-1-2 2-2 3-2l2 1v-1s0 0 0 0l2 1c1 0 0 3 2 2l1-1h-1-1c0-1 2 0 1-1v-3h0l-1 1-1-1c-1-2 5-6 3-1l2-1h-1c-1-2 2-2 2-2 1-1-2-2-2-2h1v-2h5l-2 5s0 0 0 0 0 0 0 0h1c1 1-2 2 0 2l-1 2s0 2 2 1v-1-2c1 0 0 0 0 0l3-9 1 3-1 1h1v2h2c1-1-1-1-1-2v-2l2-1h-1l-1-1 1-1v-2l1 1h3c1 1-2 5-2 5h1l1-2v1l-1 2h2s0 0 0 0h1l-1-1v-4c2-2 3 2 3 2 6 0-3-4 3-2 3 1 1 1 0 2h3s0 0 0 0h1v1l2 1h-1l-1 1-1 3c-2 1-5-1-6 1h2s0 0 0 0h2v2l1-1v2h3l-1-1v-1c0-1 0 0 0 0h3zm-41 19h0zm1 0h0zm0 0h0zm0 0h0zm0 0h0zm17-28l-2 1c-4-3 1-3 2-1zm-15 7h1v-1l1 1v-1s0 2 1 1v-1l2-1s0 0 0 0 0 0 0 0v1c-1 2-2 3-5 3l1-2s0 0 0 0h-1zm0 0h-1 1zm-6 7l1-1h1l-1 2-1-1zm-2 2l1 1h-1v-1zm-5 2c1-2 9-1 2 2l-2-2zm-13 15v1c0 1 3 1-1 2h-1c3-2 1-2 1-2l-1 1-1 1c-1-1 2-4 3-3zm-7 9v-2c4 0 1 3 0 3h-1l1-1zm-23 54v1s0 0 0 0h-2l2-1zm-18 17h2s0 0 0 0 0 0 0 0 0 0 0 0h0l-2 1v-1zm-6 36s0 0 0 0v3-3zm2-7h0s0 0 0 0c1 4-1 2 0 0h-1 1zm36-59h0zm55-76h-1 1zm-16 21h0zm0 0h0zm0 0h1-1zm1 0h0z"
				/>
				<path
					id="il"
					d="M573 519v1h-10 0l1-9-1-5 1-1v-3l4-1v-3 1l1-1h0l1 6-1-6 1 6v1s0 0 0 0v1l1 2v1h-1 1c0 2 3 8 2 10z"
				/>
				<path
					id="sa"
					d="M688 501l-10 4-4 1c-3 1-7-1-9-2l-17-5-8-2h-6-1l-13-2-12 3c-2 4-12 10-15 12l-5 4h2l1 1 9 5h88v-19z"
				/>
				<path
					id="iq"
					d="M637 416v1h2c2 2 0 2 0 3s2-1 3 1v1l2 1h1l3 4 1-1c3-1 1 2 6-1l3-1c0 2-2 2-3 3 0 3 5 4 5 6-1 2-3 1-2 1v2l-1 1v1s0 0 0 0v2s2 0 1 1l-2 1 1 1-1 1c1 3 1-1 2 1v4l2 1 3 2 2-1s0 0 0 0v1h1l4 2c0 2-3 2 0 2v1l3-1 9 2 2-2 3 3 1 1v41l-10 4-4 1c-3 1-7-1-9-2l-17-5-8-2h-6-1l-13-2-12 3v-2c0-3-2 1-2 1l-2-2 1-1-6-9s0 0 0 0l11-14c3-4 7-7 6-12l-2-5-1-8c-2-2-3-2-3-5-1-4 2-3 4-5l2-8s0 0 0 0l1-1 1-1v-3h2l2-2 7-1c2-2-1-2 2-2 2-1 1 2 2 3l3-4 1-1z"
				/>
				<path
					id="az"
					d="M619 371h0m-1-2l1 1 1-1c2 0-1 2 0 2l3-1v1h2c2 1-1 2-1 3 2 2 8 2 8 3v2l-2 1v1h1c2 0 4 2 6 1l3-1-1 2c0 2 3 0 3 2l-1 1s0 0 0 0h1l1 3h0l1-4 2-2v-1l1-3 4-6 2 1h2l1 1-2 2c1 1 3 0 3 2 1 1-3 2-1 3h2c1 1 0 2 2 1h1s2 2 3 1l1-1-2-5v-1c0-1-2-2-1-3h2v2l1-2h-1v-1l-1-2h2l-1-1-1-1c-2-2 0-1 0-3-1-2-3-5-2-6l1-2v-2h1s0 0 0 0l1-1h3l-4-2c-3 1-2 2-5 2l-1-1-1-1-3-1-4-3-6-3h1v1l-2 6v4c-1 1-5 2-6 1-2-1 3 0-2-2l-1 1-3-1-2-1h-1l-1 1h0v2h-1l1 2h1s0 0 0 0c0 1 6 0 5 3-1 4-1 1-4 1-2 1 0 2-2 2h-2s0 0 0 0v-1c-2-1-3 0-4 1l-2 3zm22 22l-3-3v-1s0 0 0 0h-3s1-3-1-2l-2 2h-2s0 0 0 0c-1 2-1-2-3-1l-2 2h2l1 2 2 1h3l1 2 5-1 2-1zm3-45h0zm0 0h0zm0 0h0zm-17 28h-1 1zm17-28h0zm0 0h0zm0 0h0zm0 0h0zm0 0h0zm0 0h0z"
				/>
				<path
					id="ir"
					d="M665 383l-1 1c-1 1-3-1-3-1h-1c-2 1-1 0-2-1h-2c-2-1 2-2 1-3 0-2-2-1-3-2l2-2-1-1h-2l-2-1-4 6-1 3v1l-2 2-1 4h-1l-4 3-5 1-1-2h-2-1l-2-1-1-2h-2 1c-6-1-2 2-2 4-1 2-4 2-3 3l2 2 1 1c1 3 0 1 1 1l3 5c0 2 1-2 2 1v6l1-1 3 1 1 3c3 2 1-1 3 2 0 0 0 0 0 0v1h2c2 2 0 2 0 3s2-1 3 1v1l2 1h1l3 4 1-1c3-1 1 2 6-1l3-1c0 2-2 2-3 3 0 3 5 4 5 6-1 2-3 1-2 1v2l-1 1v1s0 0 0 0v2s2 0 1 1l-2 1 1 1-1 1c1 3 1-1 2 1v4l2 1 3 2 2-1s0 0 0 0v1h1l4 2c0 2-3 2 0 2v1l3-1 9 2 2-2 3 3 1 1v-70h-1l-5-3-2 1h-1s0 0 0 0c-3 2-6 3-9 1l-5-6z"
				/>
				<path
					id="ge"
					d="M626 356v2h-1l1 2h1s0 0 0 0c0 1 6 0 5 3-1 4-1 1-4 1-2 1 0 2-2 2h-2s0 0 0 0v-1c-2-1-3 0-4 1-2 0-1 3-2 3l-1 1s0 0 0 0c-1 2-4 2-5 3l-6 4v0h-1l-1 1-1-1s0 1 0 0c-1 0 0 0 0 0l-2-1h-2s0 0 0 0v-1h-1l-1 1v2h-2l-3 1-1 2h-3 0v-2l1-3-5-5-2-3-2-1-1 1-2-2c-2-1-2 0-4 1l-1-1h-1v1l-2-2h-3s0 0 0 0h1c0-4 1-2 4-3l1-1 3 1 3-2 2 1 5-1c2-2-3-1 2-2h2l4-1v1h8v1c4 0 3-4 6-5l2 1 1-2c3-1 2 1 4 1l2-2h1l1 4s0 0 0 0h3l1 1 2-2 1 1h1z"
				/>
				<path
					id="sy"
					d="M562 466l2 1v-2l2-1-1-3 3-1-2-2-1-5h4s0 2 1 1v-1h3c3-2 4-7 8-7l4 1c3 0 6-2 8-4 4-2 5-6 9-9l7-3 4-3c0-1 1-3 2-2l1 2-2 8c-2 2-5 1-4 5 0 3 1 3 3 5l1 8 2 5c1 5-3 8-6 12l-16 20-10 14h-9l-2-1c-2-1-2 3-3 0l-1-6h0s0 0 0 0l3-5s-3 1-2-1l1-2 3-1-2-1 3-4h-1l-1-3h-2v-1l-1-1-3 2-2-3c-1-2 0-4-2-6l-2-1 1-2-1-1 1-2z"
				/>
				<path
					id="am"
					d="M626 374h-1 1m-7 12h1s0 0 0 0h1s0 0 0 0h0s0 0 0 0h0v1h1s0 0 0 0h0s0 0 0 0h2v1h0s0 0 0 0l2-2c2-1 2 3 3 1 0 0 0 0 0 0h2l2-2c2-1 1 2 1 2h3s0 0 0 0v1l3 3 2-2h1l1-1-1 1h0l-1-3h-1s0 0 0 0l1-1c0-2-3 0-3-2l1-2-3 1c-2 1-4-1-6-1h-1v-1l2-1v-2c0-1-6-1-8-3 0-1 3-2 1-3h-2v-1l-3 1c-1 0 2-2 0-2l-1 1-1-1s0 0 0 0l-1 1s0 0 0 0c-1 2-4 2-5 3l-6 4v0l1 1 4 3v5l2 1v1l6-2zm0-15h0z"
				/>
				<path
					id="cy"
					d="M550 474l-5 7c-1 2 3 2 3 3h-2l-1 1h-2v2l-4 3v2c-1 1-2-1-2-1l-2 1h-3l-1-1-2-3h2l1-2h3v-2-2h1l5-1 9-7z"
				/>
				<path
					id="ie"
					d="M189 275v2h-2l1 1v5 1h-1v2s0 0 0 0v3l-4 6-1 1v2s0 0 0 0h-1l-1-1h-3s0 0 0 0h-4v1h-2l-2 1c-2 2-1-1-2-1v2h-1l-1 1h-1v-1l-1 1-3-1-2 1c-2 0 1-1 0-1h-3l3-2s0 0 0 0h-5l1-1h1l-1-1h-1l-1-2h1v-1h2l2-1h-1s0 0 0 0l-3-2c-1 0 0 0 0 0s0 0 0 0h3l2 1-1-2 2-1 1-1 7 1-2-1v-1l-3 2 1-1h-2v-1l-3 1h1l2-2s0 1 0 0l1-1h1l-1-1 1-1 1-1 1 1 2-1h-1l1-1h-4c-2-1 0-1 0-2-1-2-3-1-4-2-2-2 2-1 2-1l-1-1 2-1h3c1-3-3-1-3-2h1v-2-2l-1 1v-1-1l6 1 1 2 1-1 3 2-1-2 3-1 2-1h-1-1v-1s0 0 0 0c-1 0-3 0-2-1 0-2 2 0 3 0l-1-1h1v-1l1-1c0-1-4 0 1-2h1l4 1-2 2h2v-1l1 1c-2 0-1 2-3 3h-2l1 2-4 1 5 5c4 0-1-2 3-3l1 3 1 1v1c3 2 1-1 2 0l1 1v-1z"
				/>
				<path id="path3690" d="M200 286c2 1 3 2 2 3" />
				<path id="path3688" d="M201 289h-1c-1 0 0 0 0 0-1-2-2-3 0-3" />
				<path
					id="path3684"
					d="M238 204v1h-1 1v1s0-1 0 0c0 0 0 0 0 0l-1 1-2 4h1l1-4-2 1-1-2h3l1-2z"
				/>
				<path id="path3682" d="M225 221c-1 3-7-3-3-3l1 1v1l1 1h1z" />
				<path
					id="path3680"
					d="M184 262h1l1-1h4l2 1s0 0 0 0l1 2-1 1c2 4 1-1 2 2 1 1-2 3-2 3 2-1 3-2 3 2 0 3-3 1-4 2 0 1 0 2-2 2 0 0 0 0 0 0l-1-1h-2v-1l-1-1-1-3c-4 1 1 2-3 3-2 0-5-5-5-5l4-1-1-2h2c2-1 1-3 3-3z"
				/>
				<path
					id="path3678"
					d="M202 223l-2 2-1 3-1-1c-1-1 0 1-1 2l-1-1-1 2-1-2h2c1-1-1-1-1-1l1-1h-1v-1c1-2 2 0 3 0v-2h2s0 0 0 0l2-1v1z"
				/>
				<path id="gb" d="M203 274h-1l-1 2c-4 3 2 2 2-2z" />
				<path
					id="lt"
					d="M396 277l1-1 1 2c3 1 2-1 4 1v2c1 1 4-1 5-1l2 1 1-2h1v-2h2c2-1 0-1 1-2h2s0 0 0 0h2c1-2-2-1-2-2l1-3-1-2v-1c1-3 0 1 2-2l1-2 2-1v-1l1-1h-3v-4h-1l-6-5-4 1-3-3-1 2c-1 2-1 0-2 0l-1 1h-3-4v1l-1-1-1 1h-5l-5 3v2h-1v4l1 1s0 0 0 0l1 3v1c0 1 0 0 0 0l1 1h0s0 0 0 0h1l4 1v1l4-1 1 1h1l1 1c0 1-2 3 0 6zm-14-14s0 0 0 0v5h0v-2-3c0-1 0-2 0 0z"
				/>
				<path
					id="lv"
					d="M381 258h1v-2l5-3h5l1-1 1 1v-1h7l1-1c1 0 1 2 2 0l1-2 3 3 4-1 6 5c3 0 3-3 4-3h1l1-1h1l1-3 2-2c1-2-2-5-3-6l-1-2-1 1v-1s0 0 0 0v-2h-1c0-2 2-2-1-4h-1v-1h-5l-2 2-4-3v-1l-1 1-1-1h-1l-2-1s0 0 0 0 0 0 0 0c0 2-1 0-1 0l-5 4h0s0 0 0 0c0 2 3 5 2 7 0 2-2 4-4 4h-1l-2-1-1-3-4-2-1-2-2 2-3 2c-2 2 0 5-1 7l-2 2v4h1c-1 1 0 4 1 5z"
				/>
				<path
					id="md"
					d="M440 345c2-1 3 0 4 1l4 5c2 2 9 7 10 11v7l2 4v1l1 1s0 0 0 0l1-1h1v-3l2-1v-2l1-1-1-1 1-1c0-1-3-2-1-3l1-2 1 2s0 0 0 0 0 0 0 0l1-1s0 0 0 0v-1l2 1 1-1 1 1v-1h2l-2-2s0 0 0 0l-1-3-3-1c-1 0 0-2-1-1v-3c-2-1 0 1-1 1l-3-3c-1-2 0-4-2-5l-1 1c-2-1-1-3-4-2-1 0 0 2-1 1v-1l-1 1v-1h-2s0 0 0 0l-3-2c-3 0-2 2-4 2l-4 1 1 1h-1l-1 1z"
				/>
				<path
					id="ro"
					d="M469 395h-5l-1-2-1 1c-2 1 1-1-2-1l-2 1c-1 1 0-2-4 0l-7 4-4 4c-1 2-3 1-5 1h-4l-2 1h-8c-2 0-3 2-5 1-1-1 2-3 1-3-1-1-6-2-6-4 1-1 4-1 3-2-10-5-1 0-5 2-1 1-1-1-2-1h-2-1l-1-1c0-1-4 0-2-1l2-1-2-1 1-2c-2-1-6-1-7-3v-4l-1 1-1-2-2-1-1-1v-1l4-1s-2-1 0-1h2c2 0 1-4 2-5h1l1-3v-2s0 0 0 0l1-4 1-1c0-1 0-3 2-5h2l2-3 2-2s0 0 0 0l3 1v-1l6 1 2-2c2 0 3 2 4 3l2-3c2-2 6-2 7-3 3-2-1 0 1-3l2-1h0v-1 1c2-1 3 0 4 1l4 5c2 2 9 7 10 11v7l2 4v1l1 1s0 0 0 0h1v2h5l-1-1 2-1 2-2c3-1 4 0 4 2 0 0 0 0 0 0v1l1-1v4c0 2-3 2-4 2l-1 2s1-3-1-4l-1 1 1 2-1 2 2-1v1h-1 1l-2 4 1 7h0z"
				/>
				<path
					id="bg"
					d="M455 424h-1c-4 1 2 3 0 5l-3 1-5 2v-1h-3l-1 1-1-1s0 0 0 0l-2-1h-3l-5 3-3 1-1 1h-2s0 0 0 0v-5l-3-3-1-1-3-2c0-1 2-1 1-2l-1-1s0 0 0 0v-1l-1-2c3-4 0 1 3-1l2-5-5-2c-1-1-3-5-2-6l2-1v-3l3 2c1 0-2 2-1 3 2 1 3-1 5-1h8l2-1h4c2 0 4 1 5-1l4-4 7-4c4-2 3 1 4 0l2-1c3 0 0 2 2 1l1-1 1 2h5v5l-1-1c-3 1-1 1-2 3l-1 1s0 0 0 0l1 4v2l-1 1s0 0 0 0l-1 1s1 0 0 0l-1 2c-2 2 2-1 3 1v1l3 1v1h0l-1 1-2 1c-1 0 0 0 0 0-3 0-3-2-5-1l-2 2h-2v2c-1 1-3 1-2 2z"
				/>
				<path
					id="al"
					d="M408 444l1 3c-1 3-2 0-2 3l-1 4-3 1 1 2-1 1c0 2-1 1-2 1v1h-1v-1h0v-2h-1v-2c-1 0-7-2-6-3l1-1-2-2 1-1v-1-1l1-1v-1l-1 1v-4c1-1-1 0-1-2v-2h2l-1-1v-2h-2v-2-1l-1-1 3-6 2 2 2-2 2 3h1l1 1c2 2 1 4 1 6l1 2h-1l1 2-1 1 3 5 2-1h1v1z"
				/>
				<path
					id="ee"
					d="M398 233l5-4s1 2 1 0c0 0 0 0 0 0s0 0 0 0l2 1h1l1 1 1-1v1l4 3 2-2h4l-1-2h1v-1-1l1-1h-1v-2l-2-1v-2l-2-5 1-3v-2-2c1-2 3-1 1-2l-1 1h-12s0 0 0 0c-2 0 2 1-1 1l-1-1v1l-1 2h-4v1c-1 0-4 0-5 2l1 1-4 1c-1 4 1 2 2 3l-1 3 2 2 1 3h3c1 0 1-3 3-1l-1 1v5h0zm-10-8l2 2c1 0-1-1 0 0h-1v1h-1v1l-2 1v1h-2v3l-1 1c-1-1 1-2 1-3h-1l-2-1 1-1-1-2 2 1v-2l1 1c0-3 2-2 4-3zm-4-5h1v1h2c3 2 0 1 0 2-1 2 2 0-2 2-1 1-1-2-1-2l-3-1h2l1-2z"
				/>
				<path
					id="lb"
					d="M564 502l4-1v-3 1c2-1 3-5 4-6 0 0-3 1-2-1l1-2 3-1-2-1 3-4h-1l-1-3h-2v-1l-1-1-3 2v1l-1 2s0 0 0 0v2h-1l1 4-1 2v1l-1 5v4z"
				/>
				<path id="ad" d="M230 427c-5 1-2-2-2-2 2 0 3 1 2 2z" />
				<path id="sm" d="M326 414l1-1c1-1 0 2-1 1z" />
				<path id="mc" d="M278 417l2-1-2-1-1 1 1 1c1 0-1 0 0 0z" />
				<path
					id="lu"
					d="M276 345h-2-1s0 0 0 0l-2-1h0c3 0 0-4 0-4 0-1 2-5 3-3v2l3 2c1 2-2 2-1 4z"
				/>
				<path id="li" d="M301 374v2s0 0 0 0v-2z" />

				<path
					id="ba"
					d="M386 417l-2-1h1-1l-1 4-1 1c-1 3 2 3 0 5h0l1 2c-2-3-3-2-6-4l-1-1h-2-1l1-1c1-1-3-3-3-4l-1-2h-1l-5-5-4-3h-1l1-1-1-1-2-4h-1c-1-1-1-6 1-6l3 2h1-1l2-2h2l1-1 2 1h1l1-1c1 0 3 2 4 1h1l1-1 1 1 1-1h1l1 1 1-1c2 0 1 3 2 3l5-1-2 6 2 2 2 2h1c0 2-3 0-3 1 0 0 4 4 3 5l-1-1-1 2h-3c0 1 2 2 1 3h0z"
				/>
				<path
					id="si"
					d="M361 380h-3v2h-1s0 0 0 0l-4 2c-1 1 2 4 1 5-3 2-1-2-3 1-1 1 0 1 1 1l-1 1v2c-1 1-2-1-3-1-2 0 1 1-1 1l-2-2-1-1v2c-1 2-3 0-5 1 0 0 1 0 0 0h-3s0 0 0 0l1-1c4 0 0-2-1-3v-2h-1l1-2-2-2 3-3h-1 2l2 1h3l1 1v-1l2-1v-1c2-2 4 0 6-1l1-1h3v-1c-1-1 1-1 2-1l3 4z"
				/>

				<g id="ru">
					<path
						id="ru-kaliningrad"
						d="M353 273c-2-3 0-6-1-7l-1-1s0 1 0 0l-1-1-4 1s0 0 0 0l-4-1-1-1v1s0 0 0 0h-1l1 3c0 2-5 1-5 1v-1l-4 2s0 0 0 0v2c0 1 0 3-2 4 6 1 18 0 23-2h0zm-15-9h0s0 0 0 0 0 0 0 0z"
					/>
				</g>
				<path id="mt" d="M349 509h-2 2zm2 3l-2-1 2 1z" />
				<path
					id="me"
					d="M382 427v1h2-1c2 3 2 1 3 1l1 1 2 2v1l2 1v-2-1l-1-1 3-6 2 2 2-2-1-2h1v-1l2-1-4-2v-3l-5-2-1-1-1 2h-3c0 1 2 2 1 4h0c0-1 0-2-2-2h1-1l-1 4-1 1c-1 3 2 3 0 5h0l1 2-1-1z"
				/>
				<path
					id="sr"
					d="M397 424l2 3h1l1 1c2 1 1 3 1 4h0c3 2 1-2 2-3l3-1h2v-1c1-2 1 0 3-1 2 0 5-3 6-2 0-1 2-1 1-2l-1-1s0 0 0 0v-1l-1-2c3-4 0 1 3-1l2-5-5-2c-1-1-3-5-2-6l2-1v-3l-3-2c1-1 4-1 3-2-10-5-1 0-5 2-1 1-1-1-2-1h-2-1l-1-1c0-1-4 0-2-1l2-1-2-1 1-2c-2-1-6-1-7-3v-3h-1l-1-2-2-1-1-1-2-1-2 1h-2l-3 2h-1l-2 2h0l1 4 2 1h-1v2l4 1c0 2-2 0-2 0v3s0 0 0 0c-1 1-2 1-1 2l3-1-2 6c1 3 1 1 2 2l2 2h1c0 2-3 0-3 1 0 0 4 4 3 5l5 2 1 3 2 2-1 1c2 1 0 1-1 1l1 2z"
				/>
			</g>
			{#each teams as team}
				<path
					id={team.id}
					d={team.d}
					on:click={() => {
						chooseTeam(team.id);
					}}
					class="participant"
				/>
			{/each}
			{#if chosen}
				{#each teams.filter(byChosen) as team}
					<path
						id={team.id}
						d={team.d}
						filter={chosen == team.id ? "url(#dropShadow)" : ""}
						class:chosen={chosen == team.id}
					/>
				{/each}
			{/if}
		</g>
		<path
			id="lakes"
			class="water"
			fill-rule="nonzero"
			d="M431 179l6 2 2 2 1 1 1 1v2h-2l1 1v1l1 2c-1 3-4-1-5 1-2 2 0 4 0 4l-3 1v-1l-1-1-1-1-2-3-2-2v-1l-6-4 1 1-1-1c0-2 3-4 3-5v-2-1h1l3 1 3 2zm23-2c-2 1 0-1-3-4-1-1-10-2-6-5-6-2-1-2-3-5 2 0 3 4 5 5l-1-4c4-5-4-4-7-7l9 2c1 6 2 7 5 9 5 3 4 6 3 6s0 3-2 3zm-123 47c0 3 0 6-3 8l-2 1h-2c-1 0-1 4-3 3-1-1 1-2 1-3s-2-5 0-6l2 1 1-4c1-2 4-1 6 0zm5 6v4l-1 1-1 3-1 3c-2-1 1-10 3-11zm-66 74l-2 1v3s-1 0 0 0l1 1s2-4 4-3l-1-1 2-2-3-1v-1-1h-1l-1 1c-1 4 3 2 1 3z"
		/>
	</svg>
	<div id="betfairLogo">
		<p>In association with</p>
		<svg viewBox="0 0 922 438">
			<text>Betfair</text>
			<path fill="#ffb80c" d="M-2 0h924v438H-2z" />
			<path
				fill="#1d1b17"
				fill-rule="nonzero"
				d="M318 257c5 6 13 9 23 9h6c21 0 36-6 36-30v-15c0-23-10-31-36-31h-8c-11 0-18 4-21 8v-36h-16v101h16v-6zm350 9h16v-76h-16v76zm64-76c-7 0-14 3-19 10v-10h-15v76h16v-46c0-9 5-17 17-17 9 0 13 3 14 5l10-7c-2-6-9-11-23-11zm-308 76h15c19 0 28-6 30-17l-14-4c-2 6-8 8-21 8h-3c-21 0-24-3-24-19h63v-14c0-25-13-30-34-30h-8c-16 0-36 3-36 29v18c0 25 17 29 32 29zm194-76h-6c-22 0-31 7-32 17l15 5c1-7 9-9 21-9 17 0 22 1 22 14v7h-1c-4-5-9-7-23-7h-6c-21 0-32 5-32 21v5c0 13 5 23 26 23h15c16 0 17-3 20-7h1v7h15v-49c0-21-14-27-35-27zm-134 52c0 17 11 24 24 24h19v-13h-15c-9 0-12-4-12-11v-37h22v-13h-22v-30h-16v30h-8v13h8v37zm92-50h-21v-6c0-7 4-12 13-12l16 1v-13h-22c-12 0-23 7-23 24v6h-9v13h9v61h16v-61h21v-13zm-421 53h22v20h42v-20h22l-43-50-43 50zm483-2c0 7-5 10-24 10h-4c-16 0-18-3-18-9v-4c0-7 4-10 17-10h7c12 0 22 2 22 10v3zm-320-23c0-16 11-17 26-17h1c14 0 22 3 22 19v11c0 14-3 20-22 20h-4c-18 0-23-5-23-19v-14zm-45-57h-41v20h-22l42 50 43-50h-22v-20zm134 56c0-14 7-16 23-16h3c19 0 21 5 21 14v4h-47v-2zm261-40h16v-17h-16v17z"
			/>
		</svg>
	</div>
	{#if chosen}
		<Card team={chosenTeam()} bind:chosen />
	{/if}
	<!-- <Card team={teams[0]} bind:chosen /> -->
	<div class="zoom">
		<div class="in" on:click={() => zoomIn()}>+</div>
		<div class="out" on:click={() => zoomOut()}>-</div>
	</div>
</div>

<style>
	.map {
		position: relative;
		margin: 0 auto;
	}
	svg {
		width: 100%;
		max-height: 100vh;
		display: block;
		position: relative;
		z-index: 1;
	}
	.water {
		fill: var(--water);
	}
	#outlines {
		fill: var(--tealLight);
		stroke: var(--tealDark);
		stroke-width: 0.5;
	}
	#outlines .chosen {
		stroke: var(--black);
		fill: var(--gold);
	}
	.participant {
		fill: var(--tealDark);
		stroke: var(--white);
		stroke-width: 0.5;
	}
	.participant:hover {
		fill: var(--tealDarkest);
		cursor: pointer;
	}

	#ru,
	#ru-main {
		transform: translate(43px, 5px);
	}

	.zoom {
		--sizer: 1.5rem;
		position: absolute;
		bottom: calc(var(--sizer) * 0.5);
		right: calc(var(--sizer) * 0.5);
		font-size: calc(var(--sizer) * 0.75);
		text-align: center;
		background: var(--black);
		width: calc(var(--sizer) * 1);
		height: calc(var(--sizer) * 2);
		display: grid;
		grid-auto-rows: auto;
		align-items: center;
		padding: 1px;
		gap: 1px;
	}
	.in,
	.out {
		background: var(--grey);
		width: 100%;
		height: 100%;
		cursor: pointer;
	}

	#betfairLogo {
		position: absolute;
		bottom: 1em;
		left: 1em;
		width: 90px;
		z-index: 2;
	}
	#betfairLogo p {
		margin: 0;
		font-size: 10px;
	}
	#betfairLogo svg {
		max-width: 100%;
	}
	@media only screen and (max-width: 500px) {
		#betfairLogo {
			bottom: 0.25em;
			left: 0.25em;
			width: 70px;
		}
		#betfairLogo p {
			display: none;
		}
	}
</style>
